import { StrictMode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { ROUTER_BASENAME } from './config/site'
import { registerServiceWorker } from './pwa/register'
import './styles/global.css'

const rootElement = document.getElementById('root')!
const application = (
  <StrictMode>
    <BrowserRouter basename={ROUTER_BASENAME}>
      <App />
    </BrowserRouter>
  </StrictMode>
)

if (rootElement.hasChildNodes()) hydrateRoot(rootElement, application)
else createRoot(rootElement).render(application)

registerServiceWorker()
